import _ from "lodash";

const STRIP_FIELDS = new Set([
  "_id",
  "__v",
  "createdAt",
  "updatedAt",
  "createdBy",
  "updatedBy",
  "mcaPending",
  "mcaRequestId",
  "searchText",
  "_mcaIntendedStatus",
]);

const fieldInPayload = (payload, fieldPath) =>
  _.has(payload, fieldPath) || _.get(payload, fieldPath) !== undefined;

export const extractTriggerPayload = (watchFields, payload) => {
  if (!watchFields || watchFields.length === 0) return { ...payload };
  const diff = {};
  watchFields.forEach((wf) => {
    const field = typeof wf === "string" ? wf : wf.field;
    if (fieldInPayload(payload, field)) {
      _.set(diff, field, _.get(payload, field));
    }
  });
  return Object.keys(diff).length > 0 ? diff : { ...payload };
};

export const stripServerFields = (value) => {
  if (Array.isArray(value)) {
    return value.map(stripServerFields);
  }
  if (!value || typeof value !== "object") return value;
  const next = {};
  Object.entries(value).forEach(([key, val]) => {
    if (STRIP_FIELDS.has(key)) return;
    next[key] = stripServerFields(val);
  });
  return next;
};

export const mergeProposedEntity = (originalData, payload, targetEntityId) => {
  const merged = _.merge({}, originalData ?? {}, payload ?? {});
  if (targetEntityId) merged._id = targetEntityId;
  return merged;
};

export const buildResubmitPayload = ({
  action,
  originalData,
  formValues,
  watchFields = [],
}) => {
  const cleaned = stripServerFields(formValues);
  if (action === "CREATE") {
    return cleaned;
  }
  if (action === "DELETE") {
    return {};
  }
  const diff = {};
  Object.keys(cleaned).forEach((key) => {
    const newVal = cleaned[key];
    const oldVal = _.get(originalData ?? {}, key);
    if (!_.isEqual(newVal, oldVal)) {
      diff[key] = newVal;
    }
  });
  if (Object.keys(diff).length > 0) return diff;

  if (!watchFields?.length) {
    return extractTriggerPayload([], cleaned);
  }
  return extractTriggerPayload(watchFields, cleaned);
};

export const hasPayloadContent = (payload) => {
  if (payload === null || payload === undefined) return false;
  if (typeof payload !== "object") return true;
  return Object.keys(payload).length > 0;
};
